import { Card } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import GenericChips from './GenericChip';
import { Img } from './Image';
import { Text } from './Texts';
import { useHistory } from 'react-router-dom';
import FontAwesomeIcon from './FontAwesomeIcon';
import CommonButton from './CommonButton';

const CourseCardRounded = (props) => {
    const { values, academic } = props;
    const history = useHistory();

    const getPrograms = (programs) => {
        if (!programs) return;
        return programs.map((program) => (
            <Text fontWeight="600" fontSize=".8rem" color="#888888">
                {' '}
                - {program.split('-')[1]}
            </Text>
        ));
    };

    const renderRoleIcons = () => {
        if (!values?.rol || values.rol.length === 0) return null;

        return values.rol.map((rol) => {
            const roleIcons = {
                profesor: {
                    icon: 'fa-light fa-chalkboard-user',
                    color: '#6A6A6A',
                },
                director: {
                    icon: 'fa-light fa-user-tie',
                    color: '#6A6A6A',
                },
            };

            const roleConfig = roleIcons[rol.toLowerCase()];

            if (!roleConfig) return null;

            return (
                <RoleIconWrapper key={rol}>
                    <FontAwesomeIcon
                        icon={roleConfig.icon}
                        size={24}
                        color={roleConfig.color}
                    />
                </RoleIconWrapper>
            );
        });
    };

    return (
        <CourseCardWrapper
            //onClick={() => history.push("/speedgrader")}
            onClick={() =>
                history.push(
                    academic === 'academic'
                        ? `/academico/curso/${values.id}`
                        : `/profesor/curso/${values.id}`
                )
            }
            title={values.name || 'Asignatura sin nombre'}
        >
            <ImageBanner>
                {values?.rol?.length > 0 && (
                    <ChipContainer>
                        {values.rol.length === 2 &&
                        values.rol.some(
                            (r) => r.toLowerCase() === 'profesor'
                        ) &&
                        values.rol.some(
                            (r) => r.toLowerCase() === 'director'
                        ) ? (
                            <Chip role="ambos">ambos roles</Chip>
                        ) : (
                            values.rol.map((rol) => (
                                <Chip key={rol} role={rol.toLowerCase()}>
                                    {rol.toLowerCase()}
                                </Chip>
                            ))
                        )}
                    </ChipContainer>
                )}
                <ImgFake
                    w="100%"
                    height="100%"
                    loading="lazy"
                    src={values.imagen || values.image}
                />
                {/* {values.has_pending_corrections && (
                    <Notifications>
                        <WrapperIcon>
                            <DescriptionIcon />
                            <Number>{values.pending_correction}</Number>
                        </WrapperIcon>
                    </Notifications>
                )} */}
            </ImageBanner>
            <Body>
                <GenericChips
                    title={`AULA ${
                        values?.tipo_aula?.toUpperCase() || 'INDEFINIDA'
                    }`}
                    color="#BDBDBD"
                    textColor="white"
                    padding="3px 6px"
                    fontSize=".7rem"
                />
                <Title fontWeight="600" fontSize="1.1rem">
                    {values.name || 'Asignatura sin nombre'}
                </Title>
                {getPrograms(values.programas) || ''}
                {values.has_pending_corrections ? (
                    <Text fontWeight="500" fontSize="15px" color="#B31D15">
                        Hay actividades sin corregir
                    </Text>
                ) : (
                    <Text fontWeight="500" fontSize="15px" color="#BDBDBD">
                        No hay actividades sin corregir
                    </Text>
                )}
            </Body>
            <Footer>
                <FooterIcons>{renderRoleIcons()}</FooterIcons>

                <CommonButton
                    label="Ver"
                    variant="filled"
                    style={{ padding: '10px 20px' }}
                />
            </Footer>
            {/* {values.has_pending_corrections ? (
                <Footer>
                    <p>Hay actividades sin corregir</p>
                </Footer>
            ) : (
                <Footer>
                    <p>No hay actividades sin corregir</p>
                </Footer>
            )} */}
        </CourseCardWrapper>
    );
};

export default CourseCardRounded;

const CourseCardWrapper = styled(Card)`
    width: 300px;
    height: 360px;
    border-radius: 20px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.35);
    :hover {
        box-shadow: 0px 0px 5px 3px rgba(199, 195, 195, 0.73);
        -webkit-box-shadow: 0px 0px 5px 3px rgba(199, 195, 195, 0.73);
        -moz-box-shadow: 0px 0px 5px 3px rgba(199, 195, 195, 0.73);
        img {
            transform: scale(1.1);
        }
    }

    @media (max-width: 400px) {
        width: 285px;
        height: 345px;
    }
`;

const ImageBanner = styled.div`
    width: 100%;
    height: 160px;
    position: relative;
`;

const Body = styled.div`
    flex: 1;
    background-color: white;
    position: relative;
    bottom: 20px;
    padding: 15px;
    overflow: hidden;
    :before {
        content: '';
        width: 50px;
        height: 50px;
        position: absolute;
        top: -50px;
        left: 0;
        box-shadow: -30px 0 0px 0 white;
    }
`;

const ImgFake = styled(Img)`
    transition: all 0.3s ease-in-out;
    position: relative;
    object-fit: cover;
`;

const Title = styled(Text)`
    margin: 20px 0;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    font-size: 1rem;
`;
const ChipContainer = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.2rem;
    flex-wrap: wrap;
    z-index: 3;
`;

const Chip = styled.div`
    border-radius: 120px;
    box-sizing: border-box;
    width: fit-content;
    padding: 0.5rem 1.5rem;
    color: #fff;
    font-size: 0.85rem;
    font-weight: bold;
    background-color: ${(p) =>
        p.role === 'profesor'
            ? '#EAFAF6'
            : p.role === 'director'
              ? '#E6EBF9'
              : p.role === 'ambos'
                ? '#F9F5EC'
                : '#E6EBF9'};
    color: ${(p) =>
        p.role === 'profesor'
            ? '#1E8065'
            : p.role === 'director'
              ? '#5E80DB'
              : p.role === 'ambos'
                ? '#C29F43'
                : '#5E80DB'};
    text-transform: capitalize;
    border: 1px solid
        ${(p) =>
            p.role === 'profesor'
                ? '#1E8065'
                : p.role === 'director'
                  ? '#5E80DB'
                  : p.role === 'ambos'
                    ? '#C29F43'
                    : '#5E80DB'};
`;

const RoleIconWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Footer = styled.div`
    max-width: 100%;
    min-height: 65px;
    background-color: #f1f1f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    font-size: 0.8rem;
    color: #b31d15;
    padding: 0 15px;
    margin-top: -20px;
    border-radius: 0 0 20px 20px;
`;

const FooterIcons = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;
